import { render, staticRenderFns } from "./OmnichannelStrategyModal.vue?vue&type=template&id=5cf271db&scoped=true"
import script from "./OmnichannelStrategyModal.vue?vue&type=script&lang=ts"
export * from "./OmnichannelStrategyModal.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelStrategyModal.vue?vue&type=style&index=0&id=5cf271db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf271db",
  null
  
)

export default component.exports